import { ESectionColor, Section } from '@web_opxp/components';
import { Outlet } from 'react-router';
import './Checkout.scss';

export default function Checkout() {
  return (
    <Section className="checkout-session" color={ESectionColor.blue}>
      <Outlet />
    </Section>
  );
}
